module.exports = __webpack_public_path__ + "img/pip_three_icon7.72097b16.png";